import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container } from '@mui/material';

// Minimalist layout - clean and focused design
const MinimalistLayout = ({ children, sections }) => {
  // Organize sections by their type
  const sectionsByType = sections.reduce((acc, section) => {
    if (!acc[section.type]) {
      acc[section.type] = [];
    }
    acc[section.type].push(section.component);
    return acc;
  }, {});

  return (
    <Box sx={{ width: '100%' }}>
      {/* Hero section - full width with minimal padding */}
      {sectionsByType.hero && sectionsByType.hero.map((Component, index) => (
        <Box key={`hero-${index}`} sx={{ width: '100%', mb: 2 }}>
          <Component />
        </Box>
      ))}
      
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Featured properties with minimal spacing */}
        {sectionsByType.featured && sectionsByType.featured.map((Component, index) => (
          <Box key={`featured-${index}`} sx={{ mb: 8, pt: 2 }}>
            <Component />
          </Box>
        ))}
        
        {/* Recent Blog Posts section */}
        {sectionsByType.recentPosts && sectionsByType.recentPosts.map((Component, index) => (
          <Box key={`recentPosts-${index}`} sx={{ mb: 8 }}>
            <Component />
          </Box>
        ))}
        
        {/* About section */}
        {sectionsByType.about && sectionsByType.about.map((Component, index) => (
          <Box key={`about-${index}`} sx={{ mb: 8 }}>
            <Component />
          </Box>
        ))}
        
        {/* Services section */}
        {sectionsByType.services && sectionsByType.services.map((Component, index) => (
          <Box key={`services-${index}`} sx={{ mb: 8 }}>
            <Component />
          </Box>
        ))}
        
        {/* Testimonials section */}
        {sectionsByType.testimonials && sectionsByType.testimonials.map((Component, index) => (
          <Box key={`testimonials-${index}`} sx={{ mb: 8 }}>
            <Component />
          </Box>
        ))}
        
        {/* Any additional sections */}
        {sectionsByType.additional && sectionsByType.additional.map((Component, index) => (
          <Box key={`additional-${index}`} sx={{ mb: 8 }}>
            <Component />
          </Box>
        ))}
      </Container>
      
      {/* Any custom children */}
      {children}
    </Box>
  );
};

MinimalistLayout.propTypes = {
  children: PropTypes.node,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired
    })
  ).isRequired
};

MinimalistLayout.defaultProps = {
  children: null,
  sections: []
};

export default MinimalistLayout;
